module.exports = "<button class=\"gw-btn\" ng-click=\"gotBackToHomeState()\">\r\n    {{'fnol.common.views.confirmation.Back to Homepage'|translate}}\r\n</button>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/fnol/common/components/confirmationBackButton/confirmationBackButton.html
// module id = 625
// module chunks = 0